/* import __COLOCATED_TEMPLATE__ from './single-page-app.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

interface Args {
  forLoggedInUsers: boolean;
  selectedProgrammingLanguage: string;
  disabled: boolean;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class SinglePageApp extends Component<Signature> {
  @service appService: $TSFixMe;
  @service declare intercomEventService: $TSFixMe;

  constructor(owner: never, args: Args) {
    super(owner, args);
  }

  get app() {
    return this.appService.app;
  }

  @action
  onCopyCode() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'copy_code_snippet',
      metadata: {
        installation_type: this.args.forLoggedInUsers ? 'logged_in_users' : 'visitors',
        app_type: 'single_page_app',
        programming_language: this.args.selectedProgrammingLanguage,
      },
      place: 'installation-new',
      section: 'settings',
    });
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::Web::InitialSetup::CodeSnippets::SinglePageApp': typeof SinglePageApp;
    'installation-new/web/initial-setup/code-snippets/single-page-app': typeof SinglePageApp;
  }
}
